module.exports = __webpack_public_path__ + "img/collection-engagementRingsSignature.5c23249.webp";